import React, { useState, useEffect } from 'react';
import '../../css/onboardingReferalSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { toast } from "react-toastify";
import { AiOutlineStop } from "react-icons/ai";
import CustomButton from '../../components/CustomButton';
import GifAnim from '../../components/GifAnim';
import imgStepOne from '../../assets/img/onboarding/desktop/onboarding-codigo-referal-desktop.png';
import imgStepOneTablet from '../../assets/img/onboarding/tablet/onboarding-codigo-referal-tablet.png';
import imgStepOneMobile from '../../assets/img/onboarding/mobile/onboarding-codigo-referal-mobile.png';
import { FiCheckCircle } from "react-icons/fi";
import IconNotifySuccess from '../../assets/svg/mainIconNotifySuccess.svg';              
import { errorHandling } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setClientId } from '../../features/onboardingData/onboardingUserData';

function OnboardingReferalStepOne() {

    const [isLoading, setIsLoading] = useState(true);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isClientId = useSelector((state) => state.onboardingUserData.isClientId);    
    const [referralCode, setReferralCode] = useState('');
    const [isStartingLoadingDots, setIsStartingLoadingDots] = useState(false)
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [isValidReferral, setIsValidReferral] = useState(true); 
    const [isFocused, setIsFocused] =  useState(false);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const getApplyMemberGetMember = async () => {
        try {
            setIsStartingLoadingDots(true);
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/applyMemberGetMember/fetchApplyMemberGetMember`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                'ClientId': `${isClientId}`,
                "xsrf-token": csrfToken,
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({ memberGetMemberCode: referralCode }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                setIsValidReferral(true);
                toast.success("Código adicionado! O valor fica disponível depois de associar um cartão à Carteira Virtual.", {
                    icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
                });
                hadleNav();
                setIsStartingLoadingDots(false);
            } else {
                setIsValidReferral(false);
                setIsStartingLoadingDots(false);
            }
        } catch (error) {
            setIsStartingLoadingDots(false);
            setIsValidReferral(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const hadleBtnClickSaltar = () => {
        navigate('/ativar-carteira-virtual/associar-cartao');
    };

    const hadleNav = () => {
        navigate("/ativar-carteira-virtual/associar-cartao", { state: {referralCode} });
    };

    const inputClassName = isTablet ? 
    (isValidReferral ? 'inputTextReferalSteps' : 'inputTextReferalStepsInvalid') : ( isMobile ?
        (isValidReferral ? 'inputTextReferalStepsTablet' : 'inputTextReferalStepsTabletInvalid')
        :
        (isValidReferral ? 'inputTextReferalStepsMobile' : 'inputTextReferalStepsMobileInvalid'));

    const inputClassNameFocus  = isTablet ? 
    (isValidReferral ? 'inputTextReferalSteps focused' : 'inputTextReferalStepsInvalid focused') : ( isMobile ?
        (isValidReferral ? 'inputTextReferalStepsTablet focused' : 'inputTextReferalStepsTabletInvalid focused')
        :
        (isValidReferral ? 'inputTextReferalStepsMobile focused' : 'inputTextReferalStepsMobileInvalid focused'));
    
  return (  
    <>
    <Header/> 
    { !isTablet && 
        <>
            <div className='mainBgViewContainerReferalStepsMobileTablet'></div>
        </>
    }
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? 'mainViewContainerReferalSteps' : ( isMobile ? 'mainViewContainerReferalStepsTablet' : 'mainViewContainerReferalStepsMobile')}>
        { !isTablet && 
            <>
            <div className={ isMobile ? 'mainImgViewReferalStepsTablet' : 'mainImgViewReferalStepsMobile' }>
                <img src={isTablet ? imgStepOne : ( isMobile ? imgStepOneTablet : imgStepOneMobile) } alt="imagem" className={ isMobile ?  "mainImgReferalStackTablet" : "mainImgReferalStackMobile" }/>
            </div>
            </>
        }
        <div className={  isTablet ? 'firstTxtViewContainerReferalSteps' : ( isMobile ? 'firstTxtViewContainerReferalStepsTablet' : 'firstTxtViewContainerReferalStepsMobile') }>
            <div className='firstTitleViewReferalSteps'>
                <span className={  isTablet ? 'textTitlePart1ReferalSteps' : ( isMobile ? 'textTitlePart1ReferalStepsTablet' : 'textTitlePart1ReferalStepsMobile') }>Partilharam um </span>
                <span className={  isTablet ? 'textTitlePart2ReferalSteps' : ( isMobile ? 'textTitlePart2ReferalStepsTablet' : 'textTitlePart2ReferalStepsMobile') }>Código de adesão </span>  
                <span className={  isTablet ? 'textTitlePart1ReferalSteps' : ( isMobile ? 'textTitlePart1ReferalStepsTablet' : 'textTitlePart1ReferalStepsMobile') }>consigo?</span>    
            </div>
            <div className={ isTablet ? 'secondTitleViewReferalSteps' : ( isMobile ? 'secondTitleViewReferalStepsTablet' : 'secondTitleViewReferalStepsMobile') }>
                <span className={ isTablet ? 'secondTitleViewReferalSteps' : ( isMobile ? 'secondTitleViewReferalStepsTablet' : 'secondTitleViewReferalStepsMobile') }>Insira o </span>
                <span className={ isTablet ? 'secondTitleBoldViewReferalSteps' : ( isMobile ? 'secondTitleBoldViewReferalStepsTablet' : 'secondTitleBoldViewReferalStepsMobile') }>código que recebeu com 10 caracteres </span>  
                <span className={ isTablet ? 'secondTitleViewReferalSteps' : ( isMobile ? 'secondTitleViewReferalStepsTablet' : 'secondTitleViewReferalStepsMobile') }>e ganhe saldo na Carteira Virtual.</span>
            </div>
            <div className={ isTablet ? 'secondTitleViewReferalSteps' : ( isMobile ? 'secondTitleViewReferalStepsTablet' : 'secondTitleViewReferalStepsMobile') }>Caso tenha outro código, pode inseri-lo posteriomente clicando em "Ganhar Saldo" e "Ativar Ofertas".</div>
            <div className='textFormViewReferalSteps'>
                <div className='textWrapperReferalSteps'>
                    { (isFocused || referralCode.length > 0) &&
                    <label className='label-focus'>Insira aqui o seu código</label>
                    }
                    <input 
                        className={ referralCode.length > 0 ? inputClassNameFocus : inputClassName }
                        type="text" 
                        placeholder={!isFocused ? 'Insira aqui o seu código' : undefined}
                        value={referralCode}
                        onChange={(event) => setReferralCode(event.target.value)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                </div>
                { !isValidReferral &&
                    <div className='txtViewErrorInfoReferalSteps'>
                        <div className='txtErrorInfoReferalSteps'><AiOutlineStop className='iconErrorInfoReferalSteps'/> Não conseguimos validar o seu código. Por favor, verifique se o mesmo está ativo.</div>
                    </div>
                } 
            </div>
            <div className={ isTablet ? 'btnsViewReferalSteps' : ( isMobile ? 'btnsViewReferalStepsTablet' : 'btnsViewReferalStepsMobile' )}>
                <div className={ isTablet ? 'divBtnSaltarReferalSteps' : ( isMobile ? 'divBtnSaltarReferalStepsStackTablet' : 'divBtnSaltarReferalStepsMobile' )}>
                    <CustomButton 
                        text={'Saltar'} 
                        textColor={'#00214D'}
                        onPress={hadleBtnClickSaltar} 
                        hasSubLine
                        hasSubLineSmall
                        hasSubLineSmallColor={'#00214D'}
                        fontSize={'14px'}
                    />
                </div> 
                <div className={ isTablet ? 'divBtnNextReferalSteps' : ( isMobile ? 'divBtnSaltarReferalStepsStackTablet' : 'divBtnNextReferalStepsMobile' )}>
                    <CustomButton 
                        text={'Validar'} 
                        textColor={'#00214D'}
                        onPress={getApplyMemberGetMember} 
                        color={'#15D4B6'}
                        enabled={referralCode.length > 0}
                        hasArrow
                        iconColor={'#00214D'}
                        iconType={'check'}
                        loading={isStartingLoadingDots}
                    />
                </div>    
            </div>           
        </div>
        { isTablet && 
        <>
        <div className='subFirstImgViewContainerReferalSteps'>
            <div className='firstImgViewContainerReferalSteps'>
                <div className='mainImgViewReferalSteps'>
                    <img src={isTablet ? imgStepOne : ( isMobile ? imgStepOneTablet : imgStepOneMobile) } alt="imagem" className="mainImgReferalSteps" />
                </div>
            </div>
        </div>
        </>
        }
    </div>
    }
    <Footer/> 
    </>
  )
}

export default OnboardingReferalStepOne;